<template>
<section class="section-pad" id="advertisment">
    <el-row type="flex" justify="center">
        <el-col :xs="22" :sm="22" :md="22" :lg="20" :xl="20">
            <el-row :gutter="20">
                <el-col :xs="24" :lg="12" :sm="12">
                    <router-link :to="{ name: 'search-products', query: { products: 'macbook' } }">
                        <div class="each-add">
                            <img src="/img/adds/macbook-air.jpg" alt class="img-fluid" />
                        </div>
                    </router-link>
                </el-col>
                <el-col :xs="24" :lg="12" :sm="12">
                    <router-link :to="{ name: 'search-products', query: { products: 'Iphone' } }">
                        <div class="each-add">
                            <img src="/img/iphone-12-sm-banner.jpg" alt class="img-fluid" />
                        </div>
                    </router-link>
                </el-col>
            </el-row>
        </el-col>
    </el-row>
</section>
</template>

<script>
export default {};
</script>

<style scoped lang="scss"></style>
